




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "HalfdonutProgress",
})
export default class HalfdonutProgress extends Vue {
  @Prop({ default: "0" }) val!: string;
  @Prop({ default: "#008085" }) colors!: string;
  @Prop({ default: false }) scoreAbsolute!: boolean;
  @Prop({ default: false }) hidePercentage!: boolean;

  public findsymbol(val: any) {
    if (this.hidePercentage) {
      return val && (val.includes("<") || val.includes(">")) ? parseInt(val) : val;
    }
    return val && (val.includes("<") || val.includes(">") || this.scoreAbsolute) ? parseInt(val) : val + "%";
  }
}
